<template>
    <div class="container">
        <!-- 
        <canvas width="300" height="150" style="border:1px solid #BBB;" v-insert-message="text"> </canvas>
        <input type="text" v-model="text" />
       -->
        <div class="text-canvas">
            <input class="input" type="text" id="Signature" v-bind:style="{ fontFamily: selected.value }" v-model="text" />

            <div class="row d-flex justify-content-end">
                <el-dropdown @command="handleDropdownCommand">
                    <span class="el-dropdown-link">
                        Change Style <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="(item, index) in fonts" :command="item.value" :key="index">
                            {{ item.key }}
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>

        <div class="row d-flex justify-content-end mt-4">
            <base-button size="md" :disabled="isSignatureValid" variant="warning" @click.native="clear">Clear</base-button>

            <base-button size="md" variant="primary" @click.native="apply">Apply</base-button>
        </div>
    </div>
</template>

<script>
import Utility from "@/mixins/utility/utility";
import { Dropdown, DropdownMenu, DropdownItem } from "element-ui";
import {mapGetters} from 'vuex'


export default {
    name: "alert-signature-text",
    components: {
        [Dropdown.name]: Dropdown,
        [DropdownMenu.name]: DropdownMenu,
        [DropdownItem.name]: DropdownItem
    },
    mixins: [Utility],
    props: ['input', 'font', 'hasSignature'],
    data() {
        return {
            text: "",
            selected:  {key: "Gator Script" , value:'Dancing Script' },
            fonts: [{key:'Original Gator' , value:"Qwitcher Grypen"}, {key: "Gator Script" , value:'Dancing Script' }, {key:"Formal Gator", value: "Great Vibes"}, {key:"Gator Ink" , value: 'Over The Rainbow'}]
        }
    },
  
    computed: {
        ...mapGetters({
      isPartnerAccount: "authentication/isPartnerAccount",
        
      }) ,
      isSignatureValid(){
        if(this.hasSignature && this.hasSignature !=0 && this.isPartnerAccount ){
            return true
        }else{
            return false
        }
      }
    },
    methods: {
        load() {
            this.text = this.input;
            
            if(this.font) this.selected.value = this.font;
        },
        handleDropdownCommand(command) {
            this.selected.value = command;
        },
        clear() {
            this.text = "";
        },
        apply() {
             this.$loaderApp.addRequest();
            //generate the text Signature
            this.axios.post(`/api/signatures/text`, { name: this.text, fontFamily: this.selected.value }, { config: { showToast: false } })
                .then((response) => {
                    //Load the data
                    const signature = "data:image/jpg;base64," + response.data;

                    // send signature 
                    this.$emit('onTextResult', { text: this.text, font: this.selected.value, view: signature});
                    this.$loaderApp.completeRequest();
                }).catch((err) => {
                    this.$toast.error("Error on generating the signature, Please try again later");
                     this.$loaderApp.completeRequest();
                })

        }

    }
}
</script>

<style scopped>
.text-canvas {
    padding: 50px 20px 20px 20px;
    border: 2px solid lightgrey;
}

.text-canvas .input {
    font-size: 50px;
    width: 100%;
    outline: none !important;
    border: none;
    border-bottom: 4px solid lightgreen;

}
</style>
